module.exports = __webpack_public_path__ + "img/chinesecompany93.1d887c78.png";